import { createContext } from "react";

const SocketContext = createContext({
  socket: "",
});

export default SocketContext;
